import { clsx } from "clsx"

import type { SX } from "../../theme"
import { Icon, type IconName, type IconProps } from "../Icon"
import styles from "./BackgroundIcon.module.css"

export interface BackgroundIconProps {
  name: IconName
  color?: Color
  size?: "extraSmall" | "small" | "medium" | "large"
  iconSize?: "small" | "medium" | "large"
  radius?: "circle" | 6
  variant?: "soft" | "solid"
  sx?: SX
}

export function BackgroundIcon(props: BackgroundIconProps) {
  const {
    name,
    color = "grey",
    size = "small",
    iconSize = size === "extraSmall" ? "small" : size,
    variant = "soft",
    radius = "circle",
    sx,
  } = props

  const iconColor = getIconColor(color, variant)

  return (
    <div
      className={clsx(
        styles.backgroundIcon,
        styles[`color-${color}`],
        styles[`size-${size}`],
        styles[`variant-${variant}`],
        styles[`radius-${radius}`],
      )}
      style={sx}
    >
      <Icon color={iconColor} name={name} size={iconSize} />
    </div>
  )
}

function getIconColor(
  color: Color,
  variant: "soft" | "solid",
): IconProps["color"] {
  if (variant === "soft") return `${color}11`
  if (color === "amber") return "black"
  return "white"
}

type Color = "amber" | "grey" | "purple" | "tomato" | "green" | "indigo"
